import { ElementRef, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../../services/index';
import { ErrorHandlerService } from '../../services';
import { LoginService } from '../';
import { AuthService } from "angular2-social-login";
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(route, router, loginService, alertService, socialAuthService, errorHandlerService, zone) {
        var _this = this;
        this.route = route;
        this.router = router;
        this.loginService = loginService;
        this.alertService = alertService;
        this.socialAuthService = socialAuthService;
        this.errorHandlerService = errorHandlerService;
        this.zone = zone;
        this.forgetpass = false;
        this.resendemail = false;
        this.isAccountActivatedSuccessfully = false;
        this.isUnsubscribeSuccesfully = false;
        this.isAccountActivatedUnsuccessfully = false;
        this.isPasswordChangedSuccessfully = false;
        this.isForgetPasswordLinkNotValid = false;
        this.isAccountAlreadyActivated = false;
        this.isPayPalActivationSuccessful = false;
        this.isPayPalActivationError = false;
        this.isInvitationAcceptedSuccesfully = false;
        this.isInvitationAcceptedUnsuccesfully = false;
        this.paypalActivationMessage = "";
        this.passwordChangedSuccessfullyMessage = "";
        this.forgetPasswordLinkNotValidMessage = "";
        this.model = { username: '', password: '' };
        this.forgotPassword = { username: '' };
        this.resendemailUser = { username: '' };
        this.invalid = false;
        this.userStatus = '';
        this.displayCaptchaError = 'none';
        this.noEmailError = 'none';
        // Error Handler
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "Notification !!";
        this.showErrorMessages = [];
        this.showErrorPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.isValidationError = true;
        this.loginOpen = false;
        this.showOverlay = false;
        this.signUp = false;
        this.userRegistrationTimezone = "";
        this.userLoggedInIPAddress = "";
        this.isSignUp = false;
        this.pleaseWait = false;
        this.routeUrl = "";
        this.showBanner = true;
        this.closeBanner = true;
        if (localStorage.getItem("authorization") != undefined && localStorage.getItem("authorization") != null && localStorage.getItem("authorization").length > 0) {
            this.showBanner = false;
        }
        this.accountActivationStatus = localStorage.getItem("accountActivationStatus");
        this.meetingAccept = localStorage.getItem("meetingAccept");
        if (this.meetingAccept == 'success' || this.meetingAccept == 'duplicate') {
            this.isPayPalActivationSuccessful = true;
            this.paypalActivationMessage = "Congratulations, you have successfully accepted the meeting request. Please login and find your meeting details under \"My Calendar\".";
            if (localStorage.getItem("authorization") != undefined && localStorage.getItem("authorization") != null && localStorage.getItem("authorization").length > 0) {
                this.showOnlyOverlay = true;
                this.showErrorMessageTitle = 'Info!!';
                this.showErrorMessages.push("Please wait... Redirecting to dashboard...");
                this.isValidationError = false;
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
                this.isSignUp = true;
                this.pleaseWait = true;
                setTimeout(function () {
                    _this.showOnlyOverlay = false;
                    _this.showErrorMessageTitle = '';
                    _this.showErrorMessages = [];
                    _this.showErrorModalDialog = false;
                    _this.isSignUp = false;
                    _this.pleaseWait = false;
                    _this.router.navigateByUrl('/dashboard');
                }, 5000);
            }
            setTimeout(function () {
                this.isPayPalActivationSuccessful = false;
                localStorage.removeItem("meetingAccept");
            }.bind(this), 5000);
        }
        if (this.accountActivationStatus != null) {
            if (this.accountActivationStatus == 'successful') {
                this.isAccountActivatedSuccessfully = true;
                setTimeout(function () {
                    this.isAccountActivatedSuccessfully = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'unsuccessful') {
                this.isAccountActivatedUnsuccessfully = true;
                setTimeout(function () {
                    this.isAccountActivatedUnsuccessfully = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'already') {
                this.isAccountAlreadyActivated = true;
                setTimeout(function () {
                    this.isAccountAlreadyActivated = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'Paypal.SUCCESSFUL') {
                this.isPayPalActivationSuccessful = true;
                this.paypalActivationMessage = "Congratulations, Your PayPal account has been successfully updated.";
                if (localStorage.getItem("authorization") != undefined && localStorage.getItem("authorization") != null && localStorage.getItem("authorization").length > 0) {
                    this.showOnlyOverlay = true;
                    this.showErrorMessageTitle = 'Info!!';
                    this.showErrorMessages.push("Please wait... Redirecting to dashboard...");
                    this.isValidationError = false;
                    this.showErrorPopupWidthInPercentage = "100%";
                    this.showErrorModalDialog = true;
                    this.isSignUp = true;
                    this.pleaseWait = true;
                    setTimeout(function () {
                        _this.showOnlyOverlay = false;
                        _this.showErrorMessageTitle = '';
                        _this.showErrorMessages = [];
                        _this.showErrorModalDialog = false;
                        _this.isSignUp = false;
                        _this.pleaseWait = false;
                        _this.router.navigateByUrl('/dashboard');
                    }, 2000);
                }
                setTimeout(function () {
                    this.isPayPalActivationSuccessful = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'Paypal.NO_MATCH') {
                this.isPayPalActivationError = true;
                this.paypalActivationMessage = "Sorry, the Paypal verification code you have provided is not a valid one.";
                setTimeout(function () {
                    this.isPayPalActivationError = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'Paypal.EXPIRED') {
                this.isPayPalActivationError = true;
                this.paypalActivationMessage = "Sorry, the Paypal verification link you have used to activate your PayPal account has expired."
                    + "Please login to Uvsity and update the PayPal account once more to receive a fresh link.";
                setTimeout(function () {
                    this.isPayPalActivationError = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'PasswordReset.SUCCESSFUL') {
                this.isPasswordChangedSuccessfully = true;
                this.passwordChangedSuccessfullyMessage = "Congratulations!! You have successfully changed your password.";
                setTimeout(function () {
                    this.isPasswordChangedSuccessfully = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'ValdateForgetPasswordLink.UNSUCCESSFUL') {
                this.isForgetPasswordLinkNotValid = true;
                this.forgetPasswordLinkNotValidMessage = "Sorry, the link has either expired or is not valid.";
                setTimeout(function () {
                    this.isForgetPasswordLinkNotValid = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'AcceptInvitationStatus.successful') {
                this.isInvitationAcceptedSuccesfully = true;
                setTimeout(function () {
                    this.isInvitationAcceptedSuccesfully = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'AcceptInvitationStatus.unsuccessful') {
                this.isInvitationAcceptedUnsuccesfully = true;
                setTimeout(function () {
                    this.isInvitationAcceptedUnsuccesfully = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'Unsubscribed.successful') {
                this.isUnsubscribeSuccesfully = true;
                setTimeout(function () {
                    this.isUnsubscribeSuccesfully = false;
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 5000);
            }
            else if (this.accountActivationStatus == 'howto') {
                setTimeout(function () {
                    this.GotoSection("howto");
                    localStorage.removeItem("accountActivationStatus");
                }.bind(this), 1000);
            }
        }
        var existingAuth = localStorage.getItem('authorization');
        if (existingAuth != null && existingAuth != undefined && existingAuth.length > 0) {
            //localStorage.setItem('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone.toString());
            //this.router.navigateByUrl('/dashboard');
        }
    }
    HeaderComponent.prototype.ngOnInit = function () {
        this.routeUrl = this.router.url;
        //Retrieve IP Data and find out timezone of the user
        if ((localStorage.getItem('userRegistrationTimezone') != null) && (localStorage.getItem('userLoggedInIPAddress') != null)) {
            this.userLoggedInIPAddress = localStorage.getItem('userLoggedInIPAddress');
            this.userRegistrationTimezone = localStorage.getItem('userRegistrationTimezone');
        }
        else {
            this.getDataIP();
        }
    };
    HeaderComponent.prototype.SignUpDone = function (e) {
        console.log('ee', e);
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = e.showErrorMessageTitle;
        this.showErrorMessages.push(e.showErrorMessages);
        this.isValidationError = e.isValidationError;
        this.showErrorPopupWidthInPercentage = e.showErrorPopupWidthInPercentage;
        this.showErrorModalDialog = e.showErrorModalDialog;
        this.isSignUp = e.isSignUp;
        this.loginOpen = false;
        this.showOverlay = false;
        this.forgetpass = false;
        this.signUp = false;
    };
    HeaderComponent.prototype.getDataIP = function () {
        var _this = this;
        this.loginService.userCountry().subscribe(function (result) {
            _this.userLoggedInIPAddress = result.ip;
            _this.userRegistrationTimezone = result.time_zone["name"];
            localStorage.setItem('userRegistrationTimezone', _this.userRegistrationTimezone);
            localStorage.setItem('userLoggedInIPAddress', _this.userLoggedInIPAddress);
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
        });
    };
    HeaderComponent.prototype.processAndHandleErrorThrown = function () {
        var _this = this;
        this.thrownErrorCheckerSubscriber = this.errorHandlerService.errorMessage$.subscribe(function (error) {
            _this.handleError(error);
        });
    };
    HeaderComponent.prototype.scrollToDiv = function (navigateTo) {
        localStorage.setItem("accountActivationStatus", navigateTo);
        this.router.navigate(["/login"]);
    };
    HeaderComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    HeaderComponent.prototype.googleLogin = function () {
        var _this = this;
        if (localStorage.getItem('GoogleToken') != undefined && localStorage.getItem('GoogleToken') != null) {
            this.showOnlyOverlay = true;
            this.showErrorMessageTitle = 'Info!!';
            this.showErrorMessages = [];
            this.showErrorMessages.push("Please wait... Authenticating...");
            this.isValidationError = false;
            this.showErrorPopupWidthInPercentage = "100%";
            this.showErrorModalDialog = true;
            this.isSignUp = true;
            this.pleaseWait = true;
            this.GService();
        }
        else {
            localStorage.removeItem("accountActivationStatus");
            this.socialAuthService.login('google').subscribe(function (data) {
                console.log('data', data);
                _this.showSpinner = true;
                console.log(data['idToken']);
                localStorage.setItem('GoogleToken', data['idToken']);
                if (data['idToken']) {
                    _this.showOnlyOverlay = true;
                    _this.showErrorMessageTitle = 'Info!!';
                    _this.showErrorMessages = [];
                    _this.showErrorMessages.push("Please wait... Authenticating...");
                    _this.isValidationError = false;
                    _this.showErrorPopupWidthInPercentage = "100%";
                    _this.showErrorModalDialog = true;
                    _this.isSignUp = true;
                    _this.pleaseWait = true;
                    $(".loginBtn--google").trigger("click");
                }
            }, function (error) {
                console.log('err', error);
                _this.closeErrorPopup();
            });
        }
    };
    HeaderComponent.prototype.GService = function () {
        var _this = this;
        this.loginService.loginByGoogle(localStorage.getItem('GoogleToken'), this.userRegistrationTimezone, this.userLoggedInIPAddress)
            .subscribe(function (data) {
            console.log(data);
            _this.closeErrorPopup();
            //this.showSpinner = false;
            localStorage.removeItem('GoogleToken');
            if (data.status == 200) {
                localStorage.setItem('authorization', data['_body']);
                localStorage.setItem('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone.toString());
                _this.zone.run(function () {
                    if (localStorage.getItem('regcourse')) {
                        localStorage.setItem('googleRegcourse', localStorage.getItem('regcourse'));
                        _this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + localStorage.getItem('regcourse'));
                    }
                    else if (localStorage.getItem('sponcourse')) {
                        localStorage.setItem('googleRegcourse', localStorage.getItem('sponcourse'));
                        _this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + localStorage.getItem('sponcourse'));
                    }
                    else {
                        _this.router.navigateByUrl('/dashboard');
                    }
                });
            }
        }, function (error) {
            localStorage.removeItem('GoogleToken');
            _this.closeErrorPopup();
            if (error.status == 403) {
                localStorage.setItem('authorization', error['_body']);
                //this.router.navigateByUrl('/signup');
            }
            else {
                console.log(error);
                _this.showSpinner = false;
                _this.showOnlyOverlay = true;
                _this.showErrorMessageTitle = "Error !!";
                _this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                _this.showErrorPopupWidthInPercentage = "30%";
                _this.showErrorModalDialog = true;
            }
        });
    };
    HeaderComponent.prototype.Glogout = function () {
        this.socialAuthService.logout().subscribe(function (data) { console.log(data); });
    };
    HeaderComponent.prototype.GotoSection = function (id) {
        var element = document.getElementById(id);
        var heightTopBar = (id == "sessions") ? 50 : 0;
        var headerHeight = $(".header.login").height() + heightTopBar;
        //if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });
        if (element)
            window.scroll({ top: (element.offsetTop - headerHeight), left: 0, behavior: 'smooth' });
    };
    HeaderComponent.prototype.login = function () {
        var _this = this;
        localStorage.removeItem("accountActivationStatus");
        this.invalid = false;
        this.showSpinner = true;
        console.log(this.model);
        this.loginService.login(encodeURIComponent(this.model.username), encodeURIComponent(this.model.password))
            .subscribe(function (data) {
            console.log(data);
            //this.showSpinner = false;
            if (data.status == 200) {
                localStorage.setItem('authorization', data['_body']);
                localStorage.setItem('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone.toString());
                //localStorage.setItem('authorization', JSON.stringify(this.model));
                if (localStorage.getItem('regcourse')) {
                    _this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + localStorage.getItem('regcourse'));
                }
                else if (localStorage.getItem('sponcourse')) {
                    _this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + localStorage.getItem('sponcourse'));
                }
                else {
                    _this.router.navigateByUrl('/dashboard');
                }
            }
        }, function (error) {
            if (error.status == 403) {
                localStorage.setItem('authorization', error['_body']);
                _this.router.navigateByUrl('/signup');
            }
            else {
                console.log(error);
                _this.showSpinner = false;
                _this.handleError(error);
            }
            //else{
            //this.alertService.error(error);
            //this.invalid = true;
            //wait 3 Seconds and hide
            //setTimeout(function() {
            //  this.invalid = false;
            //console.log(this.invalid);
            //}.bind(this), 3000);
            //}
        });
    };
    HeaderComponent.prototype.logout = function () {
        // remove user from local storage to log user out
        localStorage.removeItem('authorization');
        localStorage.removeItem("accountActivationStatus");
        this.router.navigate(['/login']);
    };
    HeaderComponent.prototype.submitResendEmail = function () {
        var _this = this;
        this.showSpinner = true;
        this.loginService.resendEmailPublic(this.resendemailUser.username, this.resendemailRecaptchaToken)
            .subscribe(function (data) {
            console.log(data);
            if (data.status == 200) {
                _this.resendemailUser = { username: '' };
                _this.resendemailRecaptchaToken = "";
                _this.resendemail = false;
                _this.showSpinner = false;
                _this.showErrorMessages.push("An email has been sent to the Email Id " + _this.resendemailUser.username + " with a link to activate your account.");
                _this.showErrorModalDialog = true;
                _this.showErrorMessageTitle = "Notification";
            }
        }, function (error) {
            console.log(error);
            _this.resendemailUser = { username: '' };
            _this.resendemailRecaptchaToken = "";
            _this.resendemail = false;
            _this.showSpinner = false;
            _this.handleError(error);
        });
    };
    HeaderComponent.prototype.getDisplayCaptchaError = function () {
        return this.displayCaptchaError;
    };
    HeaderComponent.prototype.getNoEmailError = function () {
        return this.noEmailError;
    };
    HeaderComponent.prototype.cancelForgotPasswordResendEmail = function () {
        this.forgetpass = false;
        this.displayCaptchaError = 'none';
        this.noEmailError = 'none';
        this.forgotPasswordRecaptchaToken = '';
        this.forgotPassword.username = '';
    };
    HeaderComponent.prototype.submitForgotPasswordResendEmail = function () {
        var _this = this;
        var isError = false;
        this.displayCaptchaError = "none";
        this.noEmailError = "none";
        if (this.forgotPasswordRecaptchaToken == "" || this.forgotPasswordRecaptchaToken == null) {
            this.displayCaptchaError = "block";
            isError = true;
        }
        if (!this.forgotPasswordRecaptchaToken) {
            this.displayCaptchaError = "block";
            isError = true;
        }
        if (this.forgotPassword.username == "" || this.forgotPassword.username == null) {
            this.noEmailError = "block";
            isError = true;
        }
        if (!this.forgotPassword.username) {
            this.noEmailError = "block";
            isError = true;
        }
        if (isError == true) {
            return;
        }
        this.showSpinner = true;
        this.loginService.forgotPasswordOrResendEmail(this.forgotPassword.username, this.forgotPasswordRecaptchaToken)
            .subscribe(function (data) {
            console.log(data);
            if (data.status == 200) {
                _this.forgotPassword = { username: '' };
                _this.forgotPasswordRecaptchaToken = "";
                _this.forgetpass = false;
                _this.showSpinner = false;
                var returnCode = data.json().returnCode;
                if (returnCode == "1") {
                    _this.showErrorMessages.push("An email has been sent to the Email Id " + _this.forgotPassword.username + " with a link to reset your password.");
                }
                else if (returnCode == "2") {
                    _this.showErrorMessages.push("An email has been sent to the Email Id " + _this.resendemailUser.username + " with a link to activate your account.");
                }
                _this.showErrorModalDialog = true;
                _this.showErrorMessageTitle = "Notification";
            }
        }, function (error) {
            console.log(error);
            _this.forgotPassword = { username: '' };
            _this.forgotPasswordRecaptchaToken = "";
            // this.forgetpass = false;
            _this.showSpinner = false;
            _this.handleError(error);
        });
    };
    HeaderComponent.prototype.closeErrorPopup = function () {
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorMessages = [];
        this.showErrorModalDialog = false;
        this.isSignUp = false;
        this.pleaseWait = false;
        this.showOnlyOverlay = false;
        if (this.userPassword != undefined)
            this.userPassword.nativeElement.focus();
    };
    HeaderComponent.prototype.handleError = function (error) {
        var _this = this;
        if (this.userPassword != undefined)
            this.userPassword.nativeElement.blur();
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        this.showSpinner = false;
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = "Error !!";
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.Uvsity_Errors) {
                console.log("Uvsity Exception");
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
            }
            else if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
            }
            this.alertService.success("Focus on Close Button");
        }
    };
    return HeaderComponent;
}());
export { HeaderComponent };
//# sourceMappingURL=header.component.js.map